import axios from "axios";
import { items, categories } from "InitialData/Items";
import { listData } from "InitialData/accounts/navBoxData";


class FileRequester {
  instance = null;

  constructor() {
    axios.defaults.withCredentials = true;
    this.instance = axios.create({
      baseURL: "https://puffuapp.com:8080/api",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      origin: "https://puffuapp.com:8080/",
      withCredentials: true,
    });
  }

  setAuthTokenHeader(token) {
    this.instance = axios.create({
      baseURL: "https://puffuapp.com:8080/api",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: token,
      },
      origin: "https://puffuapp.com:8080/",
      withCredentials: true,
    });
  }

  async upload(data) {
    try {
      let promise = new Promise((resolve, reject) => {
        let result = "";
        this.instance
          .post("open/file/upload", data)
          .then((res) => {
            result = res.data;
          })
          .catch((ex) => {
            result = ex;
          })
          .finally(() => {
            resolve(result);
          });
      });
      let result = await promise;
      return result;
    } catch (e) {

    }
  }

}

export default FileRequester;
